import { useTranslation } from "react-i18next";

import { shortenNumber } from "_common/utils";
import Icon              from "_components/atoms/icon";
import Menu              from "_components/atoms/menu";
import Typography        from "_components/atoms/typography";
import useStyles         from "_styles/templates/userProfileHeader";

const component = props => {
	const {
		anchorEl,
		broadcastingHours,
		handleClose,
		listeningHours,
		toggleDialogInfoBox,
		followerCount,
		followingCount
	} = props;

	const { classes } = useStyles ( undefined, { name: "styles" } );
	const { t }       = useTranslation ();

	return (
		<Menu
			keepMounted
			className       = { classes.menuContainer }
			onClose         = { handleClose }
			openend         = { Boolean ( anchorEl ) }
			transformOrigin = { { vertical: "top", horizontal: "right" } }
		>
			<li
				className = { classes.li }
				onClick   = { () => {
					handleClose ();
					toggleDialogInfoBox ( 0 );
				} }

			>
				<div className = { classes.statsContainer }>
					<div className = { classes.statsText }>
						<Typography
							className = "fontBold"
							title     = { shortenNumber ( followerCount ) }
						/>

						<Typography
							className = "fontGrey leftSpacing"
							title     = { t ( "profile_followers" ) }
						/>
					</div>

					<Icon
						className = { classes.forwardIcon }
						name      = "forward"
					/>

				</div>
			</li>

			<li
				className = { classes.li }
				onClick   = { () => {
					handleClose ();
					toggleDialogInfoBox ( 1 );
				} }
			>
				<div className = { classes.statsContainer }>
					<div className = { classes.statsText }>
						<Typography
							className = "fontBold"
							title     = { shortenNumber ( followingCount ) }
						/>

						<Typography
							className = "fontGrey leftSpacing"
							title     = { t ( "profile_following" ) }
						/>
					</div>

					<Icon
						className = { classes.forwardIcon }
						name      = "forward"
					/>

					{" "}

				</div>
			</li>

			<li
				// disableRipple
				className = { classes.li }
			>
				<Typography
					className = "fontBold"
					title     = { listeningHours }
				/>

				<Typography
					className = "fontGrey leftSpacing"
					title     = { t ( "profile_listen_hrs" ) }
				/>
			</li>

			<li
				// disableRipple
				className = { classes.li }
				// className = { classes.menuItem }
			>
				<Typography
					className = "fontBold"
					title     = { broadcastingHours }
				/>

				<Typography
					className = "fontGrey leftSpacing"
					title     = { t ( "profile_broadcast_hrs" ) }
				/>
			</li>
		</Menu>
	);
};

export default component;